export default __webpack_public_path__ + "static/media/setting.581127b9.svg";